<template>
  <div
    class="border mb-5 px-3 py-2 mx-6 flex dark:border-yellow-900 dark:bg-yellow-800 border-yellow-300 bg-yellow-100"
    style="user-select: contain; border-radius: 0.5rem"
  >
    <div class="flex">
      <span class="material-icons text-xl my-auto pr-2 text-yellow-400 dark:text-yellow-500">warning</span>
      <div class="w-full my-auto text-gray-800 dark:text-dark-text">{{ text }}</div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    }
  },
  setup() {
    return {}
  }
})
</script>

<style></style>
